import { getContentByVariationType } from "../../content/ContentDoneSimply";
import Store from "../../content/Store";
import {
  validateMembersDateOfBirth
} from "../../validations/MemberDetailsDateOfBirthValidation";
import { Layouts } from "../../constants/Constants";
import { getLayout } from "../../layout/Layout";


export const OnlineServicingHolMembershipNumber =
  "^([Hh]{1}[oO]{1}[Ll]{1}[/]{1}[A-Za-z]{1}[0-9]{7})$";
export const OnlineServicingAxaMembershipNumber =
  "^([Aa]{1}[Xx]{1}[Aa]{1}[/]{1}[A-Za-z]{1}[0-9]{7})$";

export const CrestMembershipNumber = "^[A-Za-z\\s]{0,3}[0-9]{7}[A-Za-z]{1}$";

export const OnlineServicingFirstName = "^(?![\\s.]+$)[a-zA-Z\\s.'-]*$";
export const OnlineServicingLastName = "^(?![\\s.]+$)[a-zA-Z\\s.'-]*$";

export const validateMemberDetails = ({
  membershipNumber,
  firstName,
  surname,
  dateOfBirth
} = {}) => {
  var validationContent = getContentByVariationType(
        getLayout() === Layouts.HOL
          ? Store.MemberDetails.contentTypes.HOL
          : Store.MemberDetails.contentTypes.Any,
        Store.MemberDetails
  );
  var errorMessagesToReturn = [];

  if (!membershipNumber) {
    errorMessagesToReturn.push(
      validationContent.validationErrors.EmptyMembershipNumber
    );
  }

  if (!firstName) {
    errorMessagesToReturn.push(
      validationContent.validationErrors.EmptyFirstName
    );
  }

  if (!surname) {
    errorMessagesToReturn.push(validationContent.validationErrors.EmptySurname);
  }

  if (!dateOfBirth) {
    errorMessagesToReturn.push(validationContent.validationErrors.EmptyDOB);
  } else if (!validateMembersDateOfBirth(dateOfBirth)) {
    errorMessagesToReturn.push(validationContent.validationErrors.InvalidDOB);
  }
  if (membershipNumber) {
    membershipNumber = membershipNumber.trim();
    const isMembershipNumberStartsWithAXA = membershipNumber
      .toLowerCase()
      .startsWith("axa");
    const isMembershipNumberStartsWithHOL = membershipNumber
      .toLowerCase()
      .startsWith("hol");

    const isCrestMembershipNumber =
      !isMembershipNumberStartsWithAXA && !isMembershipNumberStartsWithHOL;
    if (
      (isMembershipNumberStartsWithAXA &&
        !membershipNumber.match(OnlineServicingAxaMembershipNumber)) ||
      (isMembershipNumberStartsWithHOL &&
        !membershipNumber.match(OnlineServicingHolMembershipNumber)) ||
      (isCrestMembershipNumber &&
        !membershipNumber.match(CrestMembershipNumber))
    ) {
      errorMessagesToReturn.push(
        validationContent.validationErrors.InvalidMembershipNumer
      );
    }
  }

  if(firstName){
    if (
      ( !firstName.match(OnlineServicingFirstName))      
    ) {
      errorMessagesToReturn.push(
        validationContent.validationErrors.InvalidFirstName
      );
    }
  }

  if(surname){
    if (
      ( !surname.match(OnlineServicingLastName))      
    ) {
      errorMessagesToReturn.push(
        validationContent.validationErrors.InvalidLastName
      );
    }
  }

  return errorMessagesToReturn;
};
